<template>
    <div id="app">
        <toast :message="message" :visible="toastVisiable" :type="toastType"></toast>
        <router-view/>
    </div>
</template>

<script>
import toast from './components/toast';

export default {
    name: 'App',
    components: {
        toast
    },
    created() {
        // 使用自定义的 toast 组件
        this.$root.$on('showToast', data => {
            if (typeof data === 'object') {
                let {msg, type} = data;
                this.message = msg;
                this.toastType = type;
            } else if (typeof data === 'string') {
                this.message = data;
            } else {
                return;
            }
            this.toastVisiable = true;
            if (this.settimeoutId) {
                clearTimeout(this.settimeoutId);
            }
            this.settimeoutId = setTimeout(() => {
                this.toastVisiable = false;
            }, 3000);
        });
    },
    data() {
        return {
            message: '',
            toastVisiable: false,
            toastType: '',
            settimeoutId: null
        };
    }
};
</script>

<style lang="less">
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
}
p,
ul {
    margin: 0;
}
* {
    box-sizing: border-box;
}
#app {
    height: 100%;
    font-family: PingFang SC, 'Avenir', Helvetica, Arial, sans-serif;
    font-size: .28rem;
    /* -webkit-font-smoothing: antialiased; */
    /* -moz-osx-font-smoothing: grayscale; */
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.touch-active {
    opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue